import { useEffect, useState } from 'react';
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import apiclient from '../../apiclient';
import { SCENE_DETAIL } from '../../apiclient/apiEndpoints';
import Scene360 from './Scene360';

const { useUnoSelector } = UnoStoreHooks;
const { SimToggleSwitch } = UiComponents;

const Dashboard = ({ scenes }) => {
    const configData = useUnoSelector((state) => state.config);
    const userData = useUnoSelector((state) => state.user);
    const [details, setDetails] = useState(null)
    const [sceneId, setSceneId] = useState(null)
    const [sceneDetails, setSceneDetails] = useState(null)

    useEffect(() => {
        let firstSceneId = scenes?.[0]?.uuid;
        setSceneId(firstSceneId);
    }, [scenes]);

    const getSceneDetails = async (sceneId) => {
        if (!sceneId) return;
        try {
            let data = await apiclient.get(`${configData.config.API_URL}${SCENE_DETAIL}/${sceneId}`);
            setDetails(data);
            let optimizedHotspot = data.hotspots.map((item) => {
                return ({
                    hotpotView: item.hotpotView,
                    type: item.type,
                    icon: item.inventory.path,
                    uuid: data.uuid,
                    name: data.name,
                })
            });
            setSceneDetails({
                cameraView: data.cameraView,
                hotspots: optimizedHotspot,
                scene: data.inventory.path,
            });

        } catch (error) {

        }
    };
    useEffect(() => {
        getSceneDetails(sceneId);
    }, [sceneId])

    return (
        <>
            {sceneDetails && <Scene360 sceneDetails={sceneDetails} />}
        </>
    )
}

export default Dashboard
